export default __webpack_public_path__ + "static/media/rs-arte-6.a4859cce.webp";